<!-- BaseModal.vue -->
<template>
  <PopUp
    :model-value="true"
    size="md"
    :close-on-overlay="false"
    :scrollable="true"
  >
    <div class="p-6 text-left">
      <div class="flex justify-between items-center pb-3 appointment_card_top">
        <h3 class="text-2xl font-bold text-black text-[2.4rem] font-medium">
          {{ title }}
        </h3>
        <a
          href="#"
          class="location_delete_btn popup_remove_btn"
          @click.prevent="emitCloseModal"
          >x</a
        >
      </div>
      <div class="appointment_area mt-4">
        <slot></slot>
      </div>
    </div>
  </PopUp>
</template>

<script>
import PopUp from "@/components/popup/PopUp.vue";

export default {
  name: "BaseModal",
  components: { PopUp },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  methods: {
    emitCloseModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
.appointment_card_top {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
</style>
